import { techAgentId } from 'constants/history';
import { AnalyticsTarget } from 'enums/AnalyticsTarget';
import { services } from 'services/container';
import { blinkMessage } from 'state/chat/chat.actions';
import { focusMessage } from 'state/history/history.actions';
import { createReachGoalActionBy } from 'utils/analytics';

import { ChatStateController } from './chatState';
import { widgetStore } from './widgetStore';

export const showBrowserNotification = async (title: string, text?: string, msgId?: string) => {
    const state = widgetStore.store.getState();

    if (state.chat.notificationsEnabled && Notification.permission === 'granted') {
        let icon: string;

        if (msgId) {
            const agentId = state.history.messages[msgId]?.agentId;

            if (agentId && agentId !== techAgentId) {
                const agent = state.agents[agentId];
                if (agent?.avatar) {
                    icon = agent.avatar;
                }
            }
        }

        if (!icon) {
            icon = await import('!url-loader?limit=0!ico/vtb-logo.ico').then(
                (result) => result.default,
            );
        }

        const notification = new Notification(title, {
            body: text,
            icon,
        });

        services.analytics.send(createReachGoalActionBy(AnalyticsTarget.SHOW_CHAT_NOTIFICATIONS));

        notification.onclick = function (e) {
            e.preventDefault();

            window.focus();

            if (!widgetStore.store.getState().chat.open) {
                ChatStateController.toggleChat(true);
            }

            if (msgId) {
                widgetStore.store.dispatch(focusMessage(msgId));
                widgetStore.store.dispatch(blinkMessage(msgId));
            }

            this.close();
        };
    }
};

export const vibrate: typeof navigator.vibrate = (pattern) => {
    try {
        return navigator?.vibrate?.(pattern);
    } catch (e) {
        services.log.warn(`Failed to vibrate: ${String(e)}`);
    }
};
